import {Configuration, PopupRequest, SilentRequest} from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    knownAuthorities: [`${process.env.REACT_APP_KNOWN_AUTHORITIES}`],
    clientId: `${process.env.REACT_APP_CLIENT_ID}`,
    authority: `${process.env.REACT_APP_AUTHORITY}`
  }
};

export const loginRequest: PopupRequest = {
  scopes: ["User.Read"]
};

export const apiRequest: SilentRequest = {
  scopes: [`${process.env.REACT_APP_API_SCOPES}`]
};
